/**
 * Created by calhosh on 9/27/2017.
 */
import * as types from './actiontypes';

/**
 * Clear all messages in the store.
 * @returns {Object} Clear Errors action.
 */
export function clearErrors() {
	return {type: types.CLEAR_ERRORS};
}

/**
 * Raise an error from JavaScript code. This is for validation failure
 * @param {String} message - entities hierarchy
 * @return {Object} the dispatch
 @return {Function} Thunk function
 */
export function raiseJSValidationError(message) {
	return {type: types.CLIENT_VALIDATION_ERROR, message: message};
}

/**
 * Raise an SUCCESS from JavaScript code. This is for displaying success message
 * @param {String} message - entities hierarchy
 * @param {number} [autoDismissInSeconds=0] - auto dismiss time in seconds
 * @return {Object} success.
 * @return {Function} Thunk function
 */
export function raiseSuccessMessage(message, autoDismissInSeconds = 0) {
	return {type: types.SUCCESS_MESSAGE, message: message, autoDismissInSeconds};
}

/**
 * Raise an WARNING from JavaScript code. This is for displaying warning message
 * @param {String} message - entities hierarchy
 * @return {Object} warning.
 @return {Function} Thunk function
 */
export function raiseWarningMessage(message) {
	return {type: types.WARNING_MESSAGE, message: message};
}

/**
 * Raise an INFO from JavaScript code. This is for displaying info message
 * @param {String} message - entities hierarchy
 * @return {Object} info.
 @return {Function} Thunk function
 */
export function raiseInformationMessage(message) {
	return {type: types.INFO_MESSAGE, message: message};
}

export function raiseDochelperError(error) {
	return {type: types.DOCHELPER_ERROR, error: error};
}

export function raiseInvalidRelatedEntityError(error) {
	return {type: types.INVALID_RELATED_ENTITY, error: error};
}
